/**
 * This is used exclusively for FieldJob.js to map the various fields used on the page.
 *
 * TODO: the logic and data structure of this file is incredibly complex, verbose, and difficult to maintain, and therefore should be refactored. This isn't easy and will likely require changes to back-end/API.
 */

import _ from 'lodash';


export default (dataToMap) => {
    const data = dataToMap.data;
    const jobType = dataToMap.jobType;
    const metaDataJobFields = dataToMap.metaDataJobFields;
    const pickFields = dataToMap.pickFields;
    const followUpFields= dataToMap.followUpFields;
    const equipmentFields = dataToMap.equipmentFields;
    const electriciansFields = dataToMap.electriciansFields;

    const editFields = [];
    let fields = {};
    let installedQuestions = {};
    let installedFields = [];
    let surveyCompletionFields = [];
    let existingSolarFields = [];
    let panelsOptions = [];
    let electricianOptions = [];

    let outcomeField;
    let roofFields;
    let gmFields;
    let cancelledFields;
    let roofAndGmFields;
    let existingSolarQuestions;
    let completionQuestions;

    switch (jobType) {
        case 'Site Survey':
            // Fields are Overlapping, please Include every New Field in roofFields, gmFields, etc, if needed
            // depending on the completion outcome -- i.e. WHAT was completed, we can show either fields related to roof, GM, or cancelled:
            // Below Objects need refactoring
            outcomeField = {
                Site_Survey_Outcome__c: {
                    type: "outcomePick",
                    ssOutcomeOptions: pickFields.Site_Survey_Outcome__c.picklistValues.filter(item => item.active === true),
                    required: true
                }
            };

            roofFields = {
                Site_Survey_Outcome__c: {
                    type: "outcomePick",
                    ssOutcomeOptions: pickFields.Site_Survey_Outcome__c.picklistValues.filter(item => item.active === true),
                    required: true
                },
                Drone_Survey__c: {
                    type: "yesNoPick"
                },
                Structure_Levels__c: {
                    type: "num",
                },
                Rafters__c: {
                    type: "rafterPick",
                    options: pickFields.Rafters__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Rafter_Spacing__c: {
                    type: "spacingPick",
                    options: pickFields.Rafter_Spacing__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Ceiling_Type__c: {
                    type: "ceilingPick",
                    options: pickFields.Ceiling_Type__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                // TODO: limit to values 0 - 90:
                Roof_Tilt__c: {
                    type: "num",
                },
                Roof_Type__c: {
                    type: "roofPick",
                    options: pickFields.Roof_Type__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Roof_Condition__c: {
                    type: "conditionPick",
                    options: pickFields.Roof_Condition__c.picklistValues.filter(item => item.active === true)
                },
                Roof_mossy_or_slippery__c: {
                    type: "mossSlipperyPick",
                    label: "Roof mossy or slippery?",
                    options: pickFields.Roof_mossy_or_slippery__c.picklistValues.filter(item => item.active === true)
                },
                Fragile_or_lightweight_tile__c: {
                    type: "yesNoPick",
                    label: "Fragile or lightweight tile?"
                },
                Utility_Feed__c: {
                    type: "feedTypePick",
                    options: pickFields.Utility_Feed__c.picklistValues.filter(item => item.active === true)
                },
                Main_Breaker_Rating__c: {
                    type: "breakerPick",
                    options: pickFields.Main_Breaker_Rating__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                    labelAddOn: "(Verify with picture)"
                },
                Grounding__c: {
                    type: "groundingPick",
                    options: pickFields.Grounding__c.picklistValues.filter(item => item.active === true),
                    labelAddOn: "(Verify with picture)"
                },
                Any_panels_missing_dead_front__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                },
                Siding_Type__c: {
                    type: "sidingPick",
                    options: pickFields.Siding_Type__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Any_unpermitted_structures__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                },
                Manufactured_home__c: {
                    type: "yesNoPick",
                    showSubFieldIf: "Yes",
                    subField: {
                        name: "Took_pictures_of_HUD_Label_and_Decal__c",
                        label: "Took pictures of HUD Label and Decal?",
                        type: "yesNoPick",
                        displayMessageWhen: "No",
                        value: data['Took_pictures_of_HUD_Label_and_Decal__c']
                    }
                },
                Customer_was_home__c: {
                    type: "yesNoPick"
                },
                Roof_Work_Complete__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "No",
                    required: true
                },
                Ground_work_complete__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "No",
                    required: true
                },
                Is_There_Existing_Solar__c: {
                    type: "yesNoPick",
                    required: true
                },
                Internet_Available__c: {
                    type: "internetPick",
                    options: pickFields.Internet_Available__c.picklistValues.filter(item => item.active === true),
                    required: true
                },
                Needs_follow_up__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                    required: true
                },
                Dropbox_Link__c: {
                    type: "url"
                },
                Job_Notes__c: {
                    type: "textareawide"
                }
            };

            gmFields = {
                Site_Survey_Outcome__c: {
                    type: "outcomePick",
                    ssOutcomeOptions: pickFields.Site_Survey_Outcome__c.picklistValues.filter(item => item.active === true),
                    required: true
                },
                Utility_Feed__c: {
                    type: "feedTypePick",
                    options: pickFields.Utility_Feed__c.picklistValues.filter(item => item.active === true)
                },
                Main_Breaker_Rating__c: {
                    type: "breakerPick",
                    options: pickFields.Main_Breaker_Rating__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                    labelAddOn: "(Verify with picture)"
                },
                Grounding__c: {
                    type: "groundingPick",
                    options: pickFields.Grounding__c.picklistValues.filter(item => item.active === true),
                    labelAddOn: "(Verify with picture)"
                },
                Any_panels_missing_dead_front__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                },
                Siding_Type__c: {
                    type: "sidingPick",
                    options: pickFields.Siding_Type__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Any_unpermitted_structures__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                },
                Manufactured_home__c: {
                    type: "yesNoPick",
                    showSubFieldIf: "Yes",
                    subField: {
                        name: "Took_pictures_of_HUD_Label_and_Decal__c",
                        label: "Took pictures of HUD Label and Decal?",
                        type: "yesNoPick",
                        displayMessageWhen: "No",
                        value: data['Took_pictures_of_HUD_Label_and_Decal__c']
                    }
                },
                Customer_was_home__c: {
                    type: "yesNoPick"
                },
                Waste_Management_Method__c: {
                    type: "manMethodPick",
                    options: pickFields.Waste_Management_Method__c.picklistValues.filter(item => item.active === true)
                },
                Trench_Distance__c: {
                    type: "num"
                },
                Select_materials_in_the_trench_path__c: {
                    type: "trenchPathPick",
                    options: pickFields.Select_materials_in_the_trench_path__c.picklistValues.filter(item => item.active === true)
                },
                Ground_work_complete__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "No",
                    required: true
                },
                Is_There_Existing_Solar__c: {
                    type: "yesNoPick",
                    required: true
                },
                Electrical_Work_Complete__c: {
                    type: "yesNoPick",
                },
                Internet_Available__c: {
                    type: "internetPick",
                    options: pickFields.Internet_Available__c.picklistValues.filter(item => item.active === true),
                    required: true
                },
                Needs_follow_up__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                    required: true
                },
                Dropbox_Link__c: {
                    type: "url"
                },
                Job_Notes__c: {
                    type: "textareawide"
                }
            };

            cancelledFields = {
                Site_Survey_Outcome__c: {
                    type: "outcomePick",
                    ssOutcomeOptions: pickFields.Site_Survey_Outcome__c.picklistValues.filter(item => item.active === true),
                    required: true
                },
                Needs_follow_up__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                    required: true
                },
                Job_Notes__c: {
                    type: "textareawide"
                }
            };

            // the combination of `roofFields` and `gmFields`
            // the reason we're reassigning all the properties from `roofFields` and `gmFields` here instead of using `_.merge()` or `Object.assign()` is that
            // we want to preserve the order of the fields:
            roofAndGmFields = {
                Site_Survey_Outcome__c: {
                    type: "outcomePick",
                    ssOutcomeOptions: pickFields.Site_Survey_Outcome__c.picklistValues.filter(item => item.active === true),
                    required: true
                },
                Drone_Survey__c: {
                    type: "yesNoPick"
                },
                Structure_Levels__c: {
                    type: "num",
                },
                Rafters__c: {
                    type: "rafterPick",
                    options: pickFields.Rafters__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Rafter_Spacing__c: {
                    type: "spacingPick",
                    options: pickFields.Rafter_Spacing__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Ceiling_Type__c: {
                    type: "ceilingPick",
                    options: pickFields.Ceiling_Type__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                // TODO: limit to values 0 - 90
                Roof_Tilt__c: {
                    type: "num",
                },
                Roof_Type__c: {
                    type: "roofPick",
                    options: pickFields.Roof_Type__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Roof_Condition__c: {
                    type: "conditionPick",
                    options: pickFields.Roof_Condition__c.picklistValues.filter(item => item.active === true)
                },
                Roof_mossy_or_slippery__c: {
                    type: "mossSlipperyPick",
                    label: "Roof mossy or slippery?",
                    options: pickFields.Roof_mossy_or_slippery__c.picklistValues.filter(item => item.active === true)
                },
                Fragile_or_lightweight_tile__c: {
                    type: "yesNoPick",
                    label: "Fragile or lightweight tile?"
                },
                Utility_Feed__c: {
                    type: "feedTypePick",
                    options: pickFields.Utility_Feed__c.picklistValues.filter(item => item.active === true)
                },
                Main_Breaker_Rating__c: {
                    type: "breakerPick",
                    options: pickFields.Main_Breaker_Rating__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                    labelAddOn: "(Verify with picture)"
                },
                Grounding__c: {
                    type: "groundingPick",
                    options: pickFields.Grounding__c.picklistValues.filter(item => item.active === true),
                    labelAddOn: "(Verify with picture)"
                },
                Any_panels_missing_dead_front__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                },
                Siding_Type__c: {
                    type: "sidingPick",
                    options: pickFields.Siding_Type__c.picklistValues.filter(item => item.active === true),
                    displayMessageWhen: "Other",
                },
                Any_unpermitted_structures__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                },
                Manufactured_home__c: {
                    type: "yesNoPick"
                },
                Customer_was_home__c: {
                    type: "yesNoPick"
                },
                Waste_Management_Method__c: {
                    type: "manMethodPick",
                    options: pickFields.Waste_Management_Method__c.picklistValues.filter(item => item.active === true)
                },
                Trench_Distance__c: {
                    type: "num"
                },
                Select_materials_in_the_trench_path__c: {
                    type: "trenchPathPick",
                    options: pickFields.Select_materials_in_the_trench_path__c.picklistValues.filter(item => item.active === true)
                },
                Roof_Work_Complete__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "No",
                    required: true
                },
                Ground_work_complete__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "No",
                    required: true
                },
                Is_There_Existing_Solar__c: {
                    type: "yesNoPick",
                    required: true
                },
                Electrical_Work_Complete__c: {
                    type: "yesNoPick",
                },
                Internet_Available__c: {
                    type: "internetPick",
                    options: pickFields.Internet_Available__c.picklistValues.filter(item => item.active === true),
                    required: true
                },
                Needs_follow_up__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "Yes",
                    required: true
                },
                Dropbox_Link__c: {
                    type: "url"
                },
                Job_Notes__c: {
                    type: "textareawide"
                }
            };

            existingSolarQuestions = {

            };

            completionQuestions = {
                What_Was_Partially_Completed__c: {
                    type: "roofGMBothPick",
                    options: pickFields.What_Was_Partially_Completed__c.picklistValues.filter(item => item.active === true),
                    required: true,
                    ssOutcome: "Partial Completion"
                },
                What_Was_Fully_Completed__c: {
                    type: "roofGMBothPick",
                    options: pickFields.What_Was_Partially_Completed__c.picklistValues.filter(item => item.active === true),
                    required: true,
                    ssOutcome: "Full Completion"
                },
                What_Was_The_Reason_For_Cancelling__c: {
                    type: "cancelledReasonPick",
                    options: pickFields.What_Was_The_Reason_For_Cancelling__c.picklistValues.filter(item => item.active === true),
                    required: true,
                    ssOutcome: "Cancelled"
                },
            };

            // set the fields based on selected `Site_Survey_Outcome__c` and `What_Was_Partially_Completed__c` fields:
            switch (data['Site_Survey_Outcome__c']) {
                case 'Cancelled':
                    fields = _.clone(cancelledFields);
                    break;
                case 'Partial Completion':
                    if (data['What_Was_Partially_Completed__c'] === 'Roof') {
                        fields = _.clone(roofFields);
                    } else if (data['What_Was_Partially_Completed__c'] === 'GM') {
                        fields = _.clone(gmFields);
                    } else if (data['What_Was_Partially_Completed__c'] === 'Both') {
                        fields = _.clone(roofAndGmFields);
                    // copy default fields default in case `What_Was_Partially_Completed__c` is null:
                    } else {
                        fields = _.clone(roofFields);
                    }
                    break;
                case 'Full Completion':
                    if (data['What_Was_Fully_Completed__c'] === 'Roof') {
                        fields = _.clone(roofFields);
                    } else if (data['What_Was_Fully_Completed__c'] === 'GM') {
                        fields = _.clone(gmFields);
                    } else if (data['What_Was_Fully_Completed__c'] === 'Both') {
                        fields = _.clone(roofAndGmFields);
                    // copy default fields default in case `What_Was_Fully_Completed__c` is null:
                    } else {
                        fields = _.clone(roofFields);
                    }
                    break;
                default:
                    fields = _.clone(outcomeField);
                    break;
            }

            _.each(existingSolarQuestions, (value, key) => {
                let field = _.find(metaDataJobFields, (obj) => obj.name === key);

                if (field) {
                    existingSolarFields.push({
                        ...field,
                        ...value,
                        value: data[key]
                    });
                }
            });

            _.each(completionQuestions, (value, key) => {
                let field = _.find(metaDataJobFields, (obj) => obj.name === key);

                if (field) {
                    surveyCompletionFields.push({
                        ...field,
                        ...value,
                        value: data[key]
                    });
                }
            });
            break;
        case 'Inspection':
            if (data['Inspection_Outcome__c'] === 'Canceled') {
                fields = {
                    Inspection_Outcome__c: {
                        type: "cancelledReasonPick",
                        options: pickFields.Inspection_Outcome__c.picklistValues.filter(item => item.active === true),
                        required: true,
                        ssOutcome: "Cancelled"
                    },
                    What_Was_The_Reason_For_Cancelling__c: {
                        type: "cancelledReasonPick",
                        options: pickFields.What_Was_The_Reason_For_Cancelling__c.picklistValues.filter(item => item.active === true),
                        required: true,
                        ssOutcome: "Cancelled"
                    },
                    Needs_follow_up__c: {
                        type: "yesNoPick",
                        displayMessageWhen: "Yes",
                        required: true
                    },
                    Job_Notes__c: {
                        type: "textareawide"
                    }
                }
            } else {
                fields = {
                    Inspection_Outcome__c: {
                        type: "cancelledReasonPick",
                        options: pickFields.Inspection_Outcome__c.picklistValues.filter(item => item.active === true),
                        displayMessage: "This is required to save.",
                        required: true
                    },
                    Does_the_work_match_the_plans__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        required: true
                    },
                    Was_the_job_ready_for_inspection__c: {
                        type: "yesNoPick",
                        required: true,
                        showSubFieldIf: "No",
                        subField: {
                            name: "What_work_was_remaining__c",
                            label: "What work was remaining?",
                            type: "multiSelectList",
                            options: pickFields.What_work_was_remaining__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            subtext: "(Select all that apply)",
                            value: data['What_work_was_remaining__c']
                        },
                    },
                    Were_you_able_to_correct_those_items__c: {
                        type: "yesNoPick",
                        required: true,
                        displayMessageWhen: "No",
                        displayMessage: "(Add remaining work to Notes section)"
                    },
                    Job_card_uploaded_cb__c: {
                        type: "checkbox",
                        required: true
                    },
                    Any_other_notes_comments_from_the_cu__c: {
                        type: "textareawide",
                        required: true
                    },
                    Needs_follow_up__c: {
                        type: "yesNoPick",
                        displayMessageWhen: "Yes",
                        displayMessage: "Please explain in Job Notes.",
                        required: true
                    },
                    Inspection_Tech_Notes__c: {
                        type: "textareawide",
                        subtext: "(Be thorough and specific of all work and communication, additional work needed)"
                    },
                    Visible_roof_damage__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Rain_gutters_clean__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Workmanship_issues__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Trash_left_at_the_job_site__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Electrical_Work_Complete__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Clean_electrical_work__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Does_system_work_Does_it_have_S_OK__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Panels_level__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Installers_leave_work_incomplete__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Tile_replacement_flashings_secured__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Customer_knows_how_to_turn_on_system__c: {
                        type: "yesNoPick",
                        required: true
                    }
                }
            };
            break;
        case 'Install':
            if (data['Install_Outcome__c'] === 'Canceled') {
                fields = {
                    Install_Outcome__c: {
                        type: "cancelledReasonPick",
                        options: followUpFields.Install_Outcome__c.picklistValues.filter(item => item.active === true),
                        required: true,
                        ssOutcome: "Cancelled"
                    },
                    What_Was_The_Reason_For_Cancelling__c: {
                        type: "cancelledReasonPick",
                        options: followUpFields.What_Was_The_Reason_For_Cancelling__c.picklistValues.filter(item => item.active === true),
                        required: true,
                        ssOutcome: "Cancelled"
                    },
                    Needs_follow_up__c: {
                        type: "yesNoPick",
                        displayMessageWhen: "Yes",
                        required: true
                    },
                    Job_Notes__c: {
                        type: "textareawide"
                    }
                }
            } else {
                fields = {
                    Install_Outcome__c: {
                        type: "cancelledReasonPick",
                        options: followUpFields.Install_Outcome__c.picklistValues.filter(item => item.active === true),
                        required: true,
                        ssOutcome: "Cancelled"
                    },
                    Customer_verbally_approved_layout__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "Why_didn_t_CU_approve_layout__c",
                            label: "Please select why the customer didn't approve.",
                            type: "noApprovalPick",
                            options: followUpFields.Why_didn_t_CU_approve_layout__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            value: data['Why_didn_t_CU_approve_layout__c']
                        },
                        required: true
                    },
                    Does_the_work_match_the_plans__c: {
                        type: "yesNoPick",
                        required: true,
                        showSubFieldIf: "No",
                        subField: {
                            name: "Why_doesn_t_the_work_match_the_plans__c",
                            label: "Please select why they do not match.",
                            type: "multiSelectList",
                            options: followUpFields.Why_doesn_t_the_work_match_the_plans__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            subtext: "(Select all that apply)",
                            value: data['Why_doesn_t_the_work_match_the_plans__c']
                        },
                    },
                    Roof_Work_Complete__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "What_roof_work_needs_to_be_completed_C__c",
                            label: "What roof work still needs to be completed?",
                            type: "multiSelectList",
                            options: followUpFields.What_roof_work_needs_to_be_completed_C__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            subtext: "(Select all that apply)",
                            value: data['What_roof_work_needs_to_be_completed_C__c']
                        },
                        showSecondSubFieldIf: "No",
                        secondSubField: {
                            name: "Reason_for_not_completing_roof_work_C__c",
                            label: "Reason for not completing roof work?",
                            type: "noApprovalPick",
                            options: followUpFields.Reason_for_not_completing_roof_work_C__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            value: data['Reason_for_not_completing_roof_work_C__c']
                        },
                        showThirdSubFieldIf: "No",
                        thirdSubField: {
                            name: "What_type_of_tech_needs_to_be_sent_out__c",
                            label: "What type of tech needs to be sent back out?",
                            type: "multiSelectList",
                            options: followUpFields.What_type_of_tech_needs_to_be_sent_out__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            subtext: "(Select all that apply)",
                            value: data['What_type_of_tech_needs_to_be_sent_out__c']
                        },
                        showFourthSubFieldIf: "No",
                        fourthSubField: {
                            name: "Estimated_time_needed_to_finish_Roof_Ins__c",
                            label: "Estimated time needed to finish roof intall?",
                            type: "noApprovalPick",
                            options: followUpFields.Estimated_time_needed_to_finish_Roof_Ins__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            value: data['Estimated_time_needed_to_finish_Roof_Ins__c']
                        },
                        required: true
                    },
                    Did_you_have_all_equipment_necessary__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "Why_not_supplied_with_all_equipment__c",
                            label: "Why were you not supplied with all equipment necessary?",
                            type: "noApprovalPick",
                            options: followUpFields.Why_not_supplied_with_all_equipment__c.picklistValues.filter(item => item.active === true),
                            required: true
                        },
                        required: true
                    },
                    Any_broken_tiles__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "Yes",
                        subField: {
                            name: "Did_you_have_enough_tiles_to_fix_broken__c",
                            label: "Did you have enough tiles to replace what was broken?",
                            type: "yesNoPick",
                            options: false,
                            displayMessageWhen: "Other",
                            required: true
                        },
                        showSecondSubFieldIf: "Yes",
                        secondSubField: {
                            name: "How_many_tiles_are_still_needed__c",
                            label: "How many tiles are still needed?",
                            type: "num",
                            value: data['How_many_tiles_are_still_needed__c']
                        },
                        required: true
                    },
                    Customer_knows_the_status_of_the_job__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "Why_customer_doesn_t_know_status_of_job__c",
                            label: "Why does the customer not know the status of the job?",
                            subtext: "(Please leave door sign with the job status)",
                            type: "customerStatusPick",
                            options: followUpFields.Why_customer_doesn_t_know_status_of_job__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            displayMessageWhen: "Other",
                            value: data['Why_customer_doesn_t_know_status_of_job__c']
                        },
                        required: true
                    },
                    Opti_map_picture_uploaded__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Roof_conduit_painted__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Ready_for_final_inspection__c: {
                        type: "yesNoNAPick",
                        displayMessageWhen: "No",
                        required: true
                    },
                    All_Roof_photos_uploaded_cb__c: {
                        type: "checkbox",
                        required: true
                    },
                    Final_walkthrough_completed_cb__c: {
                        type: "checkbox",
                        required: true
                    },
                    Roof_Lead_Notes__c: {
                        type: "textareawide",
                        placeholder: "Enter Roof Lead Notes",
                        subtext: "(Be thorough and specific of all work and communication, additional work needed)",
                        required: true
                    },
                    Does_the_equipment_installed_match_the_p__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "CAD_Errors__c",
                            label: "CAD Errors: ",
                            type: "multiSelectList",
                            options: followUpFields.CAD_Errors__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            subtext: "(Select all that apply)",
                            value: data['CAD_Errors__c']
                        },
                        required: true
                    },
                    Solar_electrical_work_complete__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        required: true,
                        subField: {
                            name: "What_electrical_work_needs_to_be_comp__c",
                            label: "What electrical work needs to be completed?",
                            type: "multiSelectList",
                            options: followUpFields.What_electrical_work_needs_to_be_comp__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            subtext: "(Select all that apply)",
                            value: data['What_electrical_work_needs_to_be_comp__c']
                        },
                        showSecondSubFieldIf: "No",
                        secondSubField: {
                            name: "Reason_for_not_completing_SE_work__c",
                            label: "Reason for not completing solar electrical work?",
                            type: "noApprovalPick",
                            options: followUpFields.Reason_for_not_completing_SE_work__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            value: data['Reason_for_not_completing_SE_work__c']
                        },
                        showThirdSubFieldIf: "No",
                        thirdSubField: {
                            name: "What_type_of_tech_needs_to_be_sent_out__c",
                            label: "What type of tech needs to be sent back out?",
                            type: "multiSelectList",
                            options: followUpFields.What_type_of_tech_needs_to_be_sent_out__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            subtext: "(Select all that apply)",
                            value: data['What_type_of_tech_needs_to_be_sent_out__c']
                        },
                        showFourthSubFieldIf: "No",
                        fourthSubField: {
                            name: "Est_time_needed_to_finish_SE_install__c",
                            label: "Estimated time needed to finish Solar Electrical Install?",
                            type: "noApprovalPick",
                            options: followUpFields.Est_time_needed_to_finish_SE_install__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            value: data['Est_time_needed_to_finish_SE_install__c']
                        }
                    },
                    Battery_install_completed__c: {
                        type: "yesNoNAPick",
                        required: true
                    },
                    Did_you_have_all_equipment_necessary_E__c: {
                        type: "yesNoPick",
                        label: "Were you supplied with all Solar Electrical equipment necessary?",
                        showSubFieldIf: "No",
                        required: true,
                        subField: {
                            name: "Why_not_supplied_with_all_equipment__c",
                            label: "Why were you not supplied with all equipment necessary?",
                            type: "noApprovalPick",
                            options: followUpFields.Why_not_supplied_with_all_equipment__c.picklistValues.filter(item => item.active === true),
                            required: true
                        },
                    },
                    Any_damage_to_siding_stucco__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "Yes",
                        required: true,
                        subField: {
                            name: "Able_to_fix_on_site__c",
                            label: "Able to fix siding/stucco on site?",
                            type: "yesNoPick",
                            required: true
                        }
                    },
                    Customer_knows_the_status_of_the_job_E__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        required: true,
                        subField: {
                            name: "Why_customer_doesn_t_know_status_of_job__c",
                            label: "Why does the customer not know the status of the job?",
                            subtext: "(Please leave door sign with the job status)",
                            type: "customerStatusPick",
                            options: followUpFields.Why_customer_doesn_t_know_status_of_job__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            displayMessageWhen: "Other",
                            value: data['Why_customer_doesn_t_know_status_of_job__c']
                        }
                    },
                    Was_Derate_Needed__c: {
                        label: "Was Derate Needed?",
                        type: "yesNoPick"
                    },
                    Has_the_Derate_been_completed__c: {
                        label: "Has the Derate been completed?",
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "Why_was_the_derate_not_completed__c",
                            label: "Why was the derate not completed?",
                            type: "textarea"
                        }
                    },
                    Type_of_subpanel_work__c: {
                        type: "noApprovalPick",
                        label: "Type of subpanel work?",
                        options: followUpFields.Type_of_subpanel_work__c.picklistValues.filter(item => item.active === true),
                        value: data['Type_of_subpanel_work__c']
                    },
                    Was_the_subpanel_completed__c: {
                        label: "Was the subpanel completed?",
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "Why_wasn_t_the_subpanel_completed__c",
                            label: "Why wasn’t the subpanel completed?",
                            type: "textarea"
                        }
                    },
                    Has_power_been_restored_to_the_home__c: {
                        type: "yesNoPick",
                        showSubFieldIf: "No",
                        subField: {
                            name: "Why_was_power_not_restored_to_the_home__c",
                            label: "Why was power not restored to the home?",
                            type: "noApprovalPick",
                            options: followUpFields.Why_was_power_not_restored_to_the_home__c.picklistValues.filter(item => item.active === true),
                            value: data['Why_was_power_not_restored_to_the_home__c']
                        },
                    },
                    Wall_conduit_painted__c: {
                        type: "yesNoPick",
                        required: true
                    },
                    Ready_for_final_inspection_E__c: {
                        type: "checkbox",
                        required: true
                    },
                    Final_Solar_Elec_walkthrough_completed__c: {
                        label: "Final Solar Electrical walkthrough completed?",
                        type: "checkbox",
                        required: true
                    },
                    Monitoring_set_up__c: {
                        type: "checkbox",
                        required: true
                    },
                    Commissioning_Screen_Shots__c: {
                        type: "checkbox",
                        required: true
                    },
                    All_electrical_photos_uploaded__c: {
                        type: "checkbox",
                        required: true
                    },
                    Solar_Electrician_Notes__c: {
                        type: "textareawide",
                        required: true
                    }
                }
            };

            electricianOptions = _.map(electriciansFields, (item) => {
                return {
                    label: item.Name,
                    value: item.Id
                };
            });

            panelsOptions = _.map(equipmentFields, (item) => {
                return {
                    label: item.Name,
                    value: item.Id
                };
            });

            break;
        case "Service Call":
            fields = {
                Root_Cause__c: {
                    type: "textareawide",
                    required: true,
                    subtext: "(include error codes, and defective hardware info)"
                },
                // Resolution__c: {
                //     type: "textareawide",
                //     required: true,
                //     subtext: "(include replacement hardware info)"
                // },
                Has_the_problem_been_fixed__c: {
                    type: "yesNoPick",
                    required: true,
                    showSubFieldIf: "No",
                    subField: {
                        name: "Anything_else_that_needs_to_be_done__c",
                        label: "Is there anything else that needs to be done?",
                        type: "yesNoPick",
                        displayMessageWhen: "Other",
                        required: true
                    },
                    showSecondSubFieldIf: "No",
                    secondSubField: {
                        name: "Estimated_time_needed_to_resolve_Service__c",
                        label: "Estimated time needed to resolve Service Issue: ",
                        type: "noApprovalPick",
                        options: followUpFields.Estimated_time_needed_to_resolve_Service__c.picklistValues.filter(item => item.active === true),
                        required: true,
                        value: data['Estimated_time_needed_to_resolve_Service__c']
                    },
                    showThirdSubFieldIf: "No",
                    thirdSubField: {
                        name: "What_type_of_tech_needs_to_be_sent_out__c",
                        label: "What type of tech needs to be sent back out?",
                        type: "multiSelectList",
                        options: followUpFields.What_type_of_tech_needs_to_be_sent_out__c.picklistValues.filter(item => item.active === true),
                        required: true,
                        subtext: "(Select all that apply)",
                        value: data['What_type_of_tech_needs_to_be_sent_out__c']
                    },
                    showFourthSubFieldIf: "Yes",
                    fourthSubField: {
                        name: "Resolution__c",
                        label: "What did you do to resolve it?",
                        type: "textareawide",
                        required: true
                    },
                },
                Was_the_customer_home__c: {
                    type: "yesNoPick",
                    required: true,	
                    showSubFieldIf: "Yes",
                    subField: {
                        name: "Are_they_aware_of_the_situation__c",
                        label: "Are they aware of the situation?",
                        type: "yesNoPick",
                        displayMessageWhen: "Other",
                        required: true
                    },
                },
                Any_other_notes_comments_from_the_cu__c: {
                    type: "textareawide",
                    required: true
                },
                Did_the_Inverter_Optimizer_need_to_be_R__c: {
                    type: "yesNoPick",
                    required: true,
                    showSubFieldIf: "Yes",
                    subField: {
                        name: "All_panels_paired__c",
                        label: "All panels paired?",
                        type: "yesNoPick",
                        displayMessageWhen: "Other",
                        required: true
                    },
                    showSecondSubFieldIf: "Yes",
                    secondSubField: {
                        name: "S_ok__c",
                        label: "S-ok?",
                        type: "yesNoPick",
                        displayMessageWhen: "Other",
                        required: true
                    },
                    showThirdSubFieldIf: "Yes",
                    thirdSubField: {
                        name: "Case_RMA_number__c",
                        label: "Case/RMA Number: ",
                        type: "textarea",
                        displayMessageWhen: "Other",
                        required: true,
                    },
                    showFourthSubFieldIf: "Yes",
                    fourthSubField: {
                        name: "Old_Serial__c",
                        label: "Old Serial: ",
                        type: "textarea",
                        displayMessageWhen: "Other",
                        required: true,
                    },
                    showFifthSubFieldIf: "Yes",
                    fifthSubField: {
                        name: "New_Serial__c",
                        label: "New Serial: ",
                        type: "textarea",
                        displayMessageWhen: "Other",
                        required: true,
                    },
                },
                Service_Tech_Notes__c: {
                    type: "textareawide",
                    required: true
                }
                /*
                Battery_install_completed__c: {
                    type: "yesNoNAPick",
                    required: true
                },
                Is_the_customer_fully_aware_of_situation__c: {
                    type: "yesNoPick",
                    required: true
                },
                Job_Notes__c: {
                    type: "textareawide"
                }
                */
            };
            break;
        // n.b. only subfields have the `value` property:
        case "Electrical":
            switch (data.Schedulable__r.Electrical_Type__c) {
                case "MPU":
                    fields = {
                        Does_the_equipment_installed_match_the_p__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "CAD_Errors__c",
                                label: "CAD Errors: ",
                                type: "multiSelectList",
                                options: followUpFields.CAD_Errors__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                subtext: "(Select all that apply)",
                                value: data['CAD_Errors__c']
                            },
                        },
                        MPU_Complete__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Reason_for_not_completing_MPU__c",
                                label: "Reason for not completing MPU?",
                                type: "noApprovalPick",
                                options: followUpFields.Reason_for_not_completing_MPU__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Reason_for_not_completing_MPU__c']
                            },
                        },
                        AHJ_inspection_outcome__c: {
                            type: "noApprovalPick",
                            options: followUpFields.AHJ_inspection_outcome__c.picklistValues.filter(item => item.active === true),
                            required: true,
                            value: data['AHJ_inspection_outcome__c'],
                            showSubFieldIf: "Fail",
                            subField: {
                                name: "Why_did_we_fail_the_AHJ_inspection__c",
                                label: "Why did we fail the AHJ inspection?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_did_we_fail_the_AHJ_inspection__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_did_we_fail_the_AHJ_inspection__c']
                            },
                        },
                        Has_power_been_restored_to_the_home__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_was_power_not_restored_to_the_home__c",
                                label: "Why was power not restored to the home?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_was_power_not_restored_to_the_home__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_was_power_not_restored_to_the_home__c']
                            },
                        },
                        Has_the_solar_been_tied_in__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_has_the_solar_not_been_tied_in__c",
                                label: "Why has the solar not been tied in?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_has_the_solar_not_been_tied_in__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_has_the_solar_not_been_tied_in__c']
                            },
                        },
                        Battery_install_completed__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_hasn_t_the_battery_been_installed__c",
                                label: "Why hasn't the battery been installed?",
                                type: "multiSelectList",
                                options: followUpFields.Why_hasn_t_the_battery_been_installed__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                subtext: "(Select all that apply)",
                                value: data['Why_hasn_t_the_battery_been_installed__c']
                            },
                        },
                        Did_you_have_all_equipment_necessary__c: {
                            type: "yesNoPick",
                            label: "Were you supplied with all equipment necessary?",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_not_supplied_with_all_equipment__c",
                                label: "Why were you not supplied with all equipment necessary?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_not_supplied_with_all_equipment__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_not_supplied_with_all_equipment__c']
                            },
                        },
                        Any_damage_to_siding_stucco__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "Yes",
                            subField: {
                                name: "Able_to_fix_on_site__c",
                                label: "Able to fix on site?",
                                type: "yesNoPick",
                                displayMessageWhen: "Other",
                                required: true
                            },
                        },
                        Customer_knows_the_status_of_the_job__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_customer_doesn_t_know_status_of_job__c",
                                label: "Why does the customer not know the status of the job?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_customer_doesn_t_know_status_of_job__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_customer_doesn_t_know_status_of_job__c']
                            },
                        },
                        Ready_for_final_inspection__c: {
                            type: "yesNoNAPick",
                            displayMessageWhen: "No",
                            required: true
                        },
                        Wall_conduit_painted__c: {
                            type: "yesNoPick",
                            required: true
                        },
                        Final_walkthrough_completed_cb__c: {
                            type: "checkbox",
                            required: true
                        },
                        Monitoring_set_up__c: {
                            type: "checkbox",
                            required: true
                        },
                        Commissioning_Screen_Shots__c: {
                            type: "checkbox",
                            required: true
                        },
                        All_electrical_photos_uploaded__c: {
                            type: "checkbox",
                            required: true
                        },
                        Electrician_Notes__c: {
                            type: "textareawide",
                            required: true
                        }
                    }
                    break;
                case "Battery": 
                    fields = {
                        What_type_of_battery__c: {
                            type: "noApprovalPick",
                            requried: true,
                            options: followUpFields.What_type_of_battery__c.picklistValues.filter(item => item.active === true),
                            value: data['What_type_of_battery__c'],
                            showSubFieldIf: "Tesla",
                            subField: {
                                name: "Is_customer_registered_with_Tesla__c",
                                label: "Is customer registered with Tesla?",
                                type: "yesNoPick",
                                requried: true
                            },
                        },
                        Gateway_SN__c: {
                            type: "textLimited", 
                            requried: true,
                            label: "Gateway SN *"
                        },
                        Does_the_equipment_installed_match_the_p__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "CAD_Errors__c",
                                label: "CAD Errors: ",
                                type: "multiSelectList",
                                options: followUpFields.CAD_Errors__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                subtext: "(Select all that apply)",
                                value: data['CAD_Errors__c']
                            },
                        },
                        Has_the_solar_been_tied_in__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_has_the_solar_not_been_tied_in__c",
                                label: "Why has the solar not been tied in?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_has_the_solar_not_been_tied_in__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_has_the_solar_not_been_tied_in__c']
                            },
                        },
                        Battery_install_completed__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_hasn_t_the_battery_been_installed__c",
                                label: "Why hasn't the battery been installed?",
                                type: "multiSelectList",
                                options: followUpFields.Why_hasn_t_the_battery_been_installed__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                subtext: "(Select all that apply)",
                                value: data['Why_hasn_t_the_battery_been_installed__c']
                            },
                        },
                        Did_you_have_all_equipment_necessary__c: {
                            type: "yesNoPick",
                            label: "Were you supplied with all equipment necessary?",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_not_supplied_with_all_equipment__c",
                                label: "Why were you not supplied with all equipment necessary?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_not_supplied_with_all_equipment__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_not_supplied_with_all_equipment__c']
                            },
                        },
                        Any_damage_to_siding_stucco__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "Yes",
                            subField: {
                                name: "Able_to_fix_on_site__c",
                                label: "Able to fix on site?",
                                type: "yesNoPick",
                                displayMessageWhen: "Other",
                                required: true
                            },
                        },
                        Customer_knows_the_status_of_the_job__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_customer_doesn_t_know_status_of_job__c",
                                label: "Why does the customer not know the status of the job?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_customer_doesn_t_know_status_of_job__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_customer_doesn_t_know_status_of_job__c']
                            },
                        },
                        Ready_for_final_inspection__c: {
                            type: "yesNoNAPick",
                            displayMessageWhen: "No",
                            required: true
                        },
                        Wall_conduit_painted__c: {
                            type: "yesNoPick",
                            required: true
                        },
                        Tested_battery_backup_for_10_minutes__c: {
                            type: "checkbox",
                            required: true
                        },
                        Customer_confirmed_circuits__c: {
                            type: "checkbox",
                            required: true
                        },
                        Final_walkthrough_completed_cb__c: {
                            type: "checkbox",
                            required: true
                        },
                        Monitoring_set_up__c: {
                            type: "checkbox",
                            required: true
                        },
                        Commissioning_Screen_Shots__c: {
                            type: "checkbox",
                            required: true
                        },
                        Verify_CT_s_are_correct__c: {
                            type: "checkbox",
                            required: true
                        },
                        All_battery_photos_uploaded__c: {
                            type: "checkbox",
                            required: true
                        },
                        Electrician_Notes__c: {
                            type: "textareawide",
                            required: true
                        }
                    }
                    break;
                case "Miscellaneous Electrical":
                    if(data.Schedulable__r.Derate__c){
                        let derateFields = {
                            Has_the_Derate_been_completed__c: {
                                type: "yesNoPick",
                                required: true,
                                label: "Has the Deate been completed?",
                                showSubFieldIf: "No",
                                subField: {
                                    name: "Why_was_the_derate_not_completed__c",
                                    label: "Why was the derate not completed?",
                                    type: "textareawide"
                                },
                            },
                        };

                        Object.assign(fields, derateFields);
                    }

                    if(data.Schedulable__r.New_Subpanel__c || data.Schedulable__r.Subpanel_Upgrade__c){
                        let subpanelFields = {
                            Type_of_subpanel_work__c: {
                                type: "noApprovalPick",
                                label: "Type of subpanel work?",
                                required: true,
                                options: followUpFields.Type_of_subpanel_work__c.picklistValues.filter(item => item.active === true),
                                value: data['Type_of_subpanel_work__c']
                            },
                            Was_the_electrical_work_completed__c: {
                                type: "yesNoPick",
                                required: true,
                                label: "Was the electrical work completed?"
                            }
                        }
                        Object.assign(fields, subpanelFields);
                    }

                    if(data.Schedulable__r.Transfer_Switch__c){
                        let transferFields = {
                            Type_of_Transfer_Switch__c: {
                                type: "noApprovalPick",
                                label: "Type of transfer switch?",
                                required: true,
                                options: followUpFields.Type_of_Transfer_Switch__c.picklistValues.filter(item => item.active === true),
                                value: data['Type_of_Transfer_Switch__c']
                            },
                            Was_the_transfer_switch_completed__c: {
                                type: "yesNoPick",
                                label: "Was the transfer switch completed?",
                                required: true
                            }
                        }
                        Object.assign(fields, transferFields);
                    }

                    let powerField = {
                        Has_power_been_restored_to_the_home__c: {
                            type: "yesNoPick",
                            required: true,
                            showSubFieldIf: "No",
                            subField: {
                                name: "Why_was_power_not_restored_to_the_home__c",
                                label: "Why was power not restored to the home?",
                                type: "noApprovalPick",
                                options: followUpFields.Why_was_power_not_restored_to_the_home__c.picklistValues.filter(item => item.active === true),
                                required: true,
                                value: data['Why_was_power_not_restored_to_the_home__c']
                            },
                        },
                        Resolution__c: {
                            type: "textareawide"
                        },
                        Has_the_problem_been_fixed__c: {
                            type: "yesNoPick",
                            label: "Is the work 100% complete?",
                            showSubFieldIf: "No",
                            subField: {
                                name: "Reason_for_not_completing_roof_work_C__c",
                                label: "Reason for not completing work?",
                                type: "noApprovalPick",
                                options: followUpFields.Reason_for_not_completing_roof_work_C__c.picklistValues.filter(item => item.active === true),
                                value: data['Reason_for_not_completing_roof_work_C__c']
                            },
                            showSecondSubFieldIf: "No",
                            secondSubField: { 
                                name: "What_type_of_tech_needs_to_be_sent_out__c",
                                label: "What type of tech needs to be sent out?",
                                type: "noApprovalPick",
                                options: followUpFields.What_type_of_tech_needs_to_be_sent_out__c.picklistValues.filter(item => item.active === true),
                                value: data['What_type_of_tech_needs_to_be_sent_out__c']
                            }, 
                            showThirdSubFieldIf: "No",
                            thirdSubField: { 
                                name: "Estimated_time_needed_to_resolve_Service__c",
                                label: "Estimated time needed to resolve",
                                type: "noApprovalPick",
                                options: followUpFields.Estimated_time_needed_to_resolve_Service__c.picklistValues.filter(item => item.active === true),
                                value: data['Estimated_time_needed_to_resolve_Service__c']
                            }
                        }
                    }

                    let elecNotes = {
                        Electrician_Notes__c: {
                            type: "textareawide",
                            required: true
                        }
                    }

                    Object.assign(fields, powerField);
                    Object.assign(fields, elecNotes);
        
                    break;
                default:
                    break;
            }

            installedQuestions = {
                Tie_in_completed__c: {
                    type: "yesNoPick",
                    displayMessageWhen: "No",
                    required: true
                },
                Ready_for_final_inspection__c: {
                    type: "yesNoNAPick",
                    displayMessageWhen: "No",
                    required: true
                },
                System_fully_paired_and_pic_uploaded__c: {
                    type: "yesNoNAPick",
                    displayMessageWhen: "No",
                    required: true
                },
                Monitoring_fully_setup_and_pic_uploaded__c: {
                    type: "yesNoNAPick",
                    displayMessageWhen: "No",
                    required: true
                }
            };

            _.each(installedQuestions, (value, key) => {
                let field = _.find(metaDataJobFields, (obj) => obj.name === key);

                if (field) {
                    installedFields.push({
                        ...field,
                        ...value,
                        value: data[key]
                    });
                }
            });
            break;
        default:
            break;
    }

    // finally, map entire fields list with additional `name` and `value` properties:
    _.each(fields, (value, key) => {
        const metaDataJobField = _.find(metaDataJobFields, (obj) => obj.name === key);

        if (metaDataJobField) {
            editFields.push({
                ...value,
                ...metaDataJobField,
                value: data[key],
            });
        } else {
            editFields.push({
                ...value,
                name: key,
                value: data[key]
            });
        }
    });

    return {
        installedFields,
        editFields,
        surveyCompletionFields,
        existingSolarFields,
        panelsOptions,
        electricianOptions,
        followUpFields,
        pickFields
    };
};
